import { MenuItem, SiteMapItem, SiteMapTreeItem } from 'scbk-services/types/menu/menu';
import { useMenuStore } from '../stores/useMenuStore';
import { Languages, useLocale } from 'scbk-services/config';

/**
 * document title
 */
function useFindMenuTitle() {
    const { getLocale } = useLocale();
    const findMenuTitle = (menuId: string): string | null => {
        const { siteMapTree, menuTree } = useMenuStore.getState();
        if (!siteMapTree || !menuTree) {
            return null;
        }

        const findSiteMapItem = (tree: SiteMapTreeItem, menuId: string): SiteMapItem | null => {
            for (const item of Object.values(tree)) {
                if (item.id === menuId) {
                    return item;
                }

                const found = findSiteMapItem(item.children ?? {}, menuId);
                if (found) {
                    return found;
                }
            }

            return null;
        };

        const composeTitle = (menuItem: MenuItem): string | null => {
            const menu = findSiteMapItem(siteMapTree, menuId) ?? menuItem;

            const current = [
                getLocale() !== Languages.KO && menu.fields?.engName
                    ? menu.fields?.engName
                    : menu.name,
            ];

            if (menuId === menu.id) {
                return [
                    getLocale() === Languages.KO
                        ? '스탠다드차티드제일은행'
                        : 'Standardchartered Bank',
                    ...current,
                ]
                    .reverse()
                    .join(' - ');
            }

            for (const child of Object.values(menu.children ?? {})) {
                const found = composeTitle(child);
                if (found) return found;
            }
            return null;
        };

        for (const root of Object.values(menuTree)) {
            if (!root.children) continue;

            const result = composeTitle(root);
            if (result) {
                return result;
            }
        }

        return null;
    };

    return { findMenuTitle };
}

export { useFindMenuTitle };
